"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRegistrationData = void 0;
const config_1 = require("../../config/config");
const validation_1 = __importDefault(require("../../config/validation"));
class UserRegistrationData {
    static maxCharacterLimit(value, limit = validation_1.default.maxNameLength) {
        return value !== null && value.length > 0 && value.length <= limit;
    }
    constructor(data = null) {
        this.email = '';
        this.password = '';
        this.showPassword = false;
        this.firstName = '';
        this.lastName = '';
        this.dateOfBirth = undefined;
        this.gender = undefined;
        this.address = null;
        this.phone = undefined;
        this.sendUpdates = true;
        this.inviteCode = '';
        this.recaptcha = undefined;
        this.preferences = [];
        this.sourceKey = 0;
        this.getPostRequest = (lotteryId) => ({
            email: this.email,
            password: this.password,
            firstName: this.firstName,
            lastName: this.lastName,
            birthDate: this.dateOfBirth,
            gender: this.gender,
            addresses: !!this.address ? [this.address] : [],
            phones: !!this.phone ? [{ phone: this.phone }] : [],
            lotteryId,
            inviteCode: this.inviteCode,
            recaptcha: this.recaptcha,
            preferences: this.preferences,
            sourceKey: this.sourceKey,
            sendUpdates: this.sendUpdates
        });
        this.updateField = (fieldName, value) => {
            const instance = new UserRegistrationData(this);
            if (instance.hasOwnProperty(fieldName)) {
                instance[fieldName] = value;
            }
            return instance;
        };
        this.resetAdditionalInformation = () => {
            const instance = new UserRegistrationData(this);
            instance.phone = undefined;
            instance.gender = undefined;
            instance.address = null;
            return instance;
        };
        if (data !== null) {
            this.email = data.email;
            this.password = data.password;
            this.showPassword = data.showPassword;
            this.firstName = data.firstName;
            this.lastName = data.lastName;
            this.dateOfBirth = data.dateOfBirth;
            this.gender = data.gender;
            this.address = data.address;
            this.phone = data.phone;
            this.sendUpdates = data.sendUpdates;
            this.inviteCode = data.inviteCode;
            this.recaptcha = data.recaptcha;
        }
    }
    get isValidEmail() {
        if (this.email === null) {
            return false;
        }
        return this.email.length <= 100 && validation_1.default.emailValidationRegex.test(this.email.toLowerCase());
    }
    get isValidFirstName() {
        if (this.firstName === null) {
            return false;
        }
        return UserRegistrationData.maxCharacterLimit(this.firstName) && validation_1.default.nameValidationRegex.test(this.firstName);
    }
    get isValidLastName() {
        if (this.lastName === null) {
            return false;
        }
        return UserRegistrationData.maxCharacterLimit(this.lastName) && validation_1.default.nameValidationRegex.test(this.lastName);
    }
    get isValidPassword() {
        if (this.password === null) {
            return false;
        }
        return validation_1.default.passwordValidatorSchema.validate(this.password);
    }
    get passwordErrors() {
        const password = this.password === null ? '' : this.password;
        return validation_1.default.passwordValidatorSchema.validate(password, {
            list: true
        });
    }
    get passwordStrength() {
        return 0;
    }
    get isValidPhoneNumber() {
        var _a;
        if (((_a = config_1.react_core_config.internalConfig.skipPhone) !== null && _a !== void 0 ? _a : true) && !this.phone) {
            return true;
        }
        if (!this.phone || this.phone === '') {
            return false;
        }
        return (this.phone || '').length === 10;
    }
    get isValidGender() {
        var _a;
        if (((_a = config_1.react_core_config.internalConfig.skipGender) !== null && _a !== void 0 ? _a : true) && !this.gender) {
            return true;
        }
        if (!this.gender) {
            return false;
        }
        return ['MALE', 'FEMALE', 'NEUTRAL'].indexOf(this.gender) > -1;
    }
    get isValidAddress() {
        if (!this.address) {
            return false;
        }
        return (this.address.address1.length > 0 &&
            this.address.city.length > 0 &&
            this.address.zipCode.length > 0 &&
            this.address.country.length > 0 &&
            this.address.state.length > 0);
    }
    get nonEmpty() {
        return !(!this.address && !this.phone && !this.gender);
    }
    get isValidDateOfBirth() {
        return this.dateOfBirth !== undefined && this.dateOfBirth >= validation_1.default.minDateOfBirth && this.dateOfBirth <= validation_1.default.maxDateOfBirth;
    }
    get getDateOfBirth() {
        return this.dateOfBirth;
    }
    get isValidAccountCredentials() {
        return this.isValidEmail && this.isValidPassword && this.isValidFirstName && this.isValidLastName && !!this.dateOfBirth;
    }
    get isValidPersonalInformation() {
        return this.nonEmpty && this.isValidAddress && this.isValidPhoneNumber && this.isValidGender;
    }
    get isValidZipCode() {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = this.address) === null || _a === void 0 ? void 0 : _a.zipCode) === undefined && ((_b = this.address) === null || _b === void 0 ? void 0 : _b.country) === undefined) {
            return false;
        }
        const usZipCodeRegex = /^\d{5}$/;
        const canadianZipCodeRegex = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/;
        if (config_1.react_core_config.internalConfig.usaOnlyZipcode) {
            return usZipCodeRegex.test((_c = this.address) === null || _c === void 0 ? void 0 : _c.zipCode);
        }
        if (((_d = this.address) === null || _d === void 0 ? void 0 : _d.country) === 'Canada') {
            return canadianZipCodeRegex.test((_e = this.address) === null || _e === void 0 ? void 0 : _e.zipCode);
        }
        return usZipCodeRegex.test((_f = this.address) === null || _f === void 0 ? void 0 : _f.zipCode);
    }
}
exports.UserRegistrationData = UserRegistrationData;
//# sourceMappingURL=UserRegistrationData.js.map